@let $systemInfo = systemInfo();
@let $logoUrl = $systemInfo?.LogoUrl;

<div class="gapps-footer">
  @if ($systemInfo?.ProductMode === ProductMode.Resale) {
    <svg-icon-sprite
      class="text-muted"
      [height]="'20px'"
      [src]="path"
      [width]="'74px'" />
  } @else {
    @if ($logoUrl) {
      <img
        alt="logo"
        class="gapps-footer-logo"
        [src]="$logoUrl" />
    }
  }
</div>
